import React from "react";

export default function notificationsIcon({ fill }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8746 21C12.4713 21 13.0435 20.763 13.4655 20.341C13.8874 19.9191 14.1244 19.3468 14.1244 18.7501H9.62469C9.62469 19.3468 9.86173 19.9191 10.2837 20.341C10.7056 20.763 11.2779 21 11.8746 21ZM12.9939 4.23729C13.0096 4.08087 12.9923 3.9229 12.9432 3.77356C12.8941 3.62422 12.8143 3.48683 12.7088 3.37025C12.6033 3.25368 12.4746 3.16049 12.3309 3.09672C12.1872 3.03295 12.0318 3 11.8746 3C11.7174 3 11.5619 3.03295 11.4182 3.09672C11.2745 3.16049 11.1458 3.25368 11.0403 3.37025C10.9349 3.48683 10.855 3.62422 10.8059 3.77356C10.7568 3.9229 10.7396 4.08087 10.7553 4.23729C9.48376 4.49592 8.34071 5.18602 7.51967 6.19075C6.69862 7.19548 6.25004 8.45308 6.24988 9.75062C6.24988 10.9858 5.68741 16.5002 4 17.6252H19.7491C18.0617 16.5002 17.4993 10.9858 17.4993 9.75062C17.4993 7.02826 15.5644 4.75589 12.9939 4.23729V4.23729Z"
        fill={fill}
      />
    </svg>
  );
}
